export default __webpack_public_path__ + "static/media/bg.daad51ee.png";